import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { InfoIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { useEscaCopy } from '../../i18n/escaCopy';
export function ClassicShortlist() {
  const {
    lang
  } = useLanguage();
  const c = useEscaCopy(lang);
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const total = c.shortlist.stages.length;
  return <section className="relative py-20 lg:py-28 bg-navy-50/50 overflow-hidden" data-id="element-838" data-mp="23jfs4a0rpbcg">
      <div className="absolute inset-0 pointer-events-none" data-id="element-839" data-mp="23hd3nuf9jq9u">
        <div className="absolute bottom-0 left-1/4 w-[400px] h-[400px] rounded-full bg-primary-100/20 blur-3xl hidden sm:block" data-id="element-840" data-mp="1oldojztqkpv7" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref} data-id="element-841" data-mp="1tn34ntvtftq5">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-842" data-mp="i63b6uxqf8uj">
          <motion.div initial={{
          opacity: 0,
          x: -24
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.55
        }} data-id="element-843" data-mp="i40btkaow3d5">
            <span className="text-sm font-semibold text-primary-600 tracking-wide uppercase" data-id="element-844" data-mp="33qh0f2xbedea">
              {lang === 'EN' ? 'The result' : 'Результат роботи'}
            </span>
            <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy-900 tracking-tight" data-id="element-845" data-mp="3coj5btk65q6u">
              {c.shortlist.title}
            </h2>
            <p className="mt-4 text-lg text-navy-500 leading-relaxed" data-id="element-846" data-mp="3mnrwyfrkasq1">
              {c.shortlist.lead}
            </p>

            <ul className="mt-8 flex flex-wrap gap-2.5" data-id="element-847" data-mp="4aanngj6qjtg">
              {c.shortlist.deliverables.map(d => <li key={d} className="px-4 py-2 rounded-lg bg-white border border-navy-200 text-sm font-medium text-navy-700 shadow-sm" data-id="element-848" data-mp="98iyk6i1fk3">
                  {d}
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 24
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.55,
          delay: 0.1
        }} className="p-6 lg:p-8 rounded-2xl bg-white border border-navy-200 shadow-xl shadow-navy-200/30" data-id="element-849" data-mp="331mve6915j7a">
            <div className="flex items-center gap-2 mb-6" data-id="element-850" data-mp="3gsi5flv9m6cg">
              <InfoIcon className="w-3.5 h-3.5 text-navy-400" data-id="element-851" data-mp="3gu35fr0cmhhp" />
              <span className="text-[0.6875rem] tracking-wide uppercase text-navy-400 font-semibold" data-id="element-852" data-mp="3lqtgu117kows">
                {c.shortlist.demoNote}
              </span>
            </div>

            <div className="space-y-2.5" data-id="element-853" data-mp="3ut2qypskeg9n">
              {c.shortlist.stages.map((s, i) => {
              const width = 100 - i / total * 40;
              const isLast = i === total - 1;
              return <motion.div key={s.label} initial={{
                opacity: 0,
                x: -12
              }} animate={isInView ? {
                opacity: 1,
                x: 0
              } : {}} transition={{
                duration: 0.5,
                delay: 0.2 + i * 0.09
              }} style={{
                width: `${width}%`
              }} className={`flex items-baseline gap-4 px-5 py-4 rounded-xl ${isLast ? 'bg-gradient-to-r from-primary-600 to-primary-500 text-white shadow-lg shadow-primary-600/20' : 'bg-navy-50 border border-navy-200'}`} data-id="element-854" data-mp="20fjn6y7xy1fw" data-mpi={i}>
                    <span className={`text-2xl font-extrabold tabular-nums ${isLast ? 'text-white' : 'text-navy-900'}`} data-id="element-855" data-mp="2btlcooh5mu5r">
                      {s.value}
                    </span>
                    <span className={`text-xs leading-snug ${isLast ? 'text-white/85' : 'text-navy-500'}`} data-id="element-856" data-mp="22uq455qn17za">
                      {s.label}
                    </span>
                  </motion.div>;
            })}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}